import React from 'react';
import { color as palette } from "@/constants/palette";

function LeftChevron() {
  return (
    <svg aria-hidden="true" focusable="false"
      xmlns='http://www.w3.org/2000/svg'
      width='38'
      height='38'
      viewBox='0 0 38 38'
      fill='none'
    >
      <rect width='38' height='38' rx='19' fill={palette.heading} fillOpacity='0.2' />
      <path
        d='M22 11L14 19L22 27'
        stroke='white'
        strokeWidth='2.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export default LeftChevron;
